import { createSelector } from "reselect";

import getUser from "../base_getters/get_user";

const getGcpBearerTokensByOrganization = createSelector([
  getUser
], (user) => user?.gcpBearerTokensByFirebaseOrganizationId || null);

export default getGcpBearerTokensByOrganization;
